import { Layers3 } from 'lucide-react';

/**
 * Shown when the highlights step reports `completed` but the artifact carries
 * no carousels - a real backend outcome for a lesson whose source had nothing
 * card-shaped to summarise, not a loading state.
 *
 * Extracted from `LessonHighlightsCarousel` so it has a resting story; it is
 * rendered from two places there (the carousel's own empty branch, and the
 * reader's guard when a concept index no longer resolves).
 */
export function HighlightsEmptyState() {
  return (
    <div className='flex h-full flex-col items-center justify-center gap-2 px-6 text-center'>
      <Layers3 className='h-8 w-8 text-muted-foreground' />
      <p className='text-sm text-muted-foreground'>
        Highlights will appear here once generation completes.
      </p>
    </div>
  );
}
